// extracted by mini-css-extract-plugin
export default {"root":"FaTwitter_root__zIS0K"};